import { render } from "./File.vue?vue&type=template&id=444dd1aa&scoped=true"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"

import "./File.vue?vue&type=style&index=0&id=444dd1aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-444dd1aa"

export default script